import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _type_of(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { localizePath } from "@faire/retailer-visitor-shared/lib/localizationUtils";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { getLocationOrThrow } from "@faire/web--source/common/globals/getLocation";
import { makeObservable } from "@faire/web--source/common/makeObservable";
import { isWindowUndefined } from "@faire/web--source/common/server-side-rendering/isWindowUndefined";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { createStoreHook } from "@faire/web--source/ui/hooks/useStore";
import { createBrowserHistory, createMemoryHistory } from "history";
import cloneDeep from "lodash/cloneDeep";
import defer from "lodash/defer";
import { action, computed, observable } from "mobx";
import qs from "query-string";
var logger = require("debug")("IF:HISTORY");
/**
 * @deprecated prefer to use `useAppHistory` or `withStores` instead
 */ export var AppHistory = /*#__PURE__*/ function() {
    "use strict";
    function AppHistory(history) {
        var _this = this;
        _class_call_check(this, AppHistory);
        this.pastLocations = observable.array();
        /**
         * @deprecated Use withRouter or withQueryParams to inject location as a prop
         */ this.currentLocation = function() {
            return cloneDeep(_this.pastLocations[_this.pastLocations.length - 1]);
        };
        this.previousLocation = function() {
            if (_this.pastLocations.length < 2) {
                return undefined;
            }
            return cloneDeep(_this.pastLocations[_this.pastLocations.length - 2]);
        };
        this.previousPaths = function() {
            return cloneDeep(_this.pastLocations.map(function(location) {
                return location.pathname;
            }));
        };
        this.isPreviousLocationWithinApp = function() {
            return _this.pastLocations.length > 1;
        };
        /**
         * Supports including the query in the path or specifying an additional
         * object with the query params.
         */ this.goTo = function(path, query) {
            if (query) {
                if (path.includes("?")) {
                    throw new Error("Query params included in both path and in the query object");
                }
                var queryString = qs.stringify(query);
                if (queryString) {
                    path = "".concat(path, "?").concat(queryString);
                }
            }
            _this.history.push(localizePath(path));
        };
        /**
         * Use this only if you want to go to the last location in the app.
         *
         * If you are exiting out of a modal you probably want to use this
         * function to remove the modal path from your history.
         *
         * goBack takes a required location because sometimes going back
         * take us out of the react app. In this case we should replace
         * the location with the provided path.
         */ this.goBack = function(location, state) {
            if (_this.isPreviousLocationWithinApp()) {
                _this.history.goBack();
            } else {
                if (typeof location === "string") {
                    _this.replace(location, state);
                } else {
                    _this.replace(location);
                }
            }
        };
        this.replace = function(location, state) {
            if (typeof location === "string") {
                _this.history.replace(localizePath(location), state);
            } else {
                _this.history.replace(location);
            }
        };
        this.updatePastLocations = function(location, historyAction) {
            defer(function() {
                logger(historyAction, location);
                switch(historyAction){
                    case "PUSH":
                        _this.pushLocation(location);
                        break;
                    case "REPLACE":
                        _this.replaceLocation(location);
                        break;
                    case "POP":
                        {
                            _this.popLocation(location);
                            break;
                        }
                    default:
                }
            });
        };
        this.pushLocation = function(location) {
            _this.pastLocations.push(location);
        };
        this.replaceLocation = function(location) {
            var updatedPastLocations = _this.pastLocations.slice(0, -1);
            updatedPastLocations.push(location);
            _this.pastLocations.replace(updatedPastLocations);
        };
        this.popLocation = function(location) {
            var updatedPastLocations = _this.pastLocations.slice(0, -1);
            var previousLocation = updatedPastLocations[updatedPastLocations.length - 1];
            if (!previousLocation || previousLocation.key !== location.key) {
                updatedPastLocations = [
                    location
                ];
            }
            _this.pastLocations.replace(updatedPastLocations);
        };
        this.addQuery = function(restOfQuery) {
            _this.history.replace(_object_spread_props(_object_spread({}, _this.history.location), {
                search: qs.stringify(_object_spread({}, _this.query, restOfQuery))
            }));
        };
        this.getLocationWithQueryParamsAdded = function(params) {
            var _this_location;
            return _object_spread_props(_object_spread({}, (_this_location = _this.location) !== null && _this_location !== void 0 ? _this_location : {
                pathname: "",
                search: "",
                hash: "",
                state: undefined
            }), {
                search: qs.stringify(_object_spread({}, _this.query, params))
            });
        };
        this.getLocationWithQueryParamAdded = function(name, value) {
            return _this.getLocationWithQueryParamsAdded(_define_property({}, name, value));
        };
        makeObservable(this);
        var memoryHistory = getGlobalProperty("memoryHistory");
        if (history) {
            this.history = history;
        } else if (memoryHistory) {
            // Used in Next.js during migration from react-router to app-router.
            this.history = memoryHistory;
        } else if (!isWindowUndefined()) {
            this.history = createBrowserHistory({
                basename: undefined
            });
        } else {
            var location = getLocationOrThrow();
            this.history = createMemoryHistory({
                initialEntries: [
                    "".concat(location.pathname).concat(location.search).concat(location.hash)
                ],
                initialIndex: 0
            });
        }
        this.pastLocations.push(this.history.location);
        this.history.listen(this.updatePastLocations);
    }
    _create_class(AppHistory, [
        {
            key: "location",
            get: /**
     * @deprecated Use withRouter or withQueryParams to inject location as a prop
     */ function get() {
                return this.currentLocation();
            }
        },
        {
            key: "potentiallyStaleQuery",
            get: /**
     * Returns a parsed representation of history.location.search. It is possible for this value
     * to not reflect the browser's actual location.search momentarily depending on the order that
     * components are reacting to changes.
     *
     * @deprecated nothing should use this.
     */ function get() {
                var _this_location;
                var _this_location_search;
                return qs.parse((_this_location_search = (_this_location = this.location) === null || _this_location === void 0 ? void 0 : _this_location.search) !== null && _this_location_search !== void 0 ? _this_location_search : "");
            }
        },
        {
            key: "query",
            get: /**
     * @deprecated Use withQueryParams to inject queryParams as a prop
     *
     * Returns a parsed representation of history.location.search.
     *
     * NOTE this cannot be annoated as @computed because it is relying on the browser's
     * history.location object which is not observable.
     */ function get() {
                // Crazy hack... we dereference potentiallyStaleQuery here which IS observable so that
                // consumers of this class building reactions on the query can continue working.
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                this.potentiallyStaleQuery;
                // Using raw history.location here because it will always be true, this.location can become stale.
                return qs.parse(this.history.location.search);
            }
        }
    ]);
    return AppHistory;
}();
AppHistory.get = singletonGetter(AppHistory);
__decorate([
    computed
], AppHistory.prototype, "location", null);
__decorate([
    computed
], AppHistory.prototype, "potentiallyStaleQuery", null);
__decorate([
    action
], AppHistory.prototype, "pushLocation", void 0);
__decorate([
    action
], AppHistory.prototype, "replaceLocation", void 0);
__decorate([
    action
], AppHistory.prototype, "popLocation", void 0);
/**
 * @deprecated -- use useHistory from react-router-dom instead
 */ export var useAppHistory = createStoreHook(AppHistory);
